import { REACT_HOST } from '../hooks/env-variables'

let colours = {
  white: 'rgb(255, 255, 255)',
  greyVeryLight: 'rgb(233, 236, 239)',
  greyLight: 'rgb(171, 177, 182)',
  grey: 'rgb(108, 117, 125)',
  greyDark: 'rgb(57, 62, 68)',
  greyVeryDark: 'rgb(26, 29, 32)',
  black: 'rgb(0, 0, 0)',
  backDrop: 'rgba(0, 0, 0, 0.5)',
  highlight: 'rgb(255, 255, 220)',
  highlightBlue: 'rgb(210, 235, 255)',
  highlightGreen: 'rgb(220, 255, 220)',
  goldenSet: 'rgb(255,235,50)',
  green: 'rgb(0, 155, 0)',
  greenExcel: 'rgb(29, 111, 66)',
  greenExcelHover: 'rgba(29, 111, 66, 0.88)',
  blueLight: 'rgb(65, 130, 225)',
  blue: 'rgb(55, 110, 210)',
  blueDark: 'rgb(45, 90, 195)',
  blueVeryDark: 'rgb(35, 70, 180)',
  redLight: 'rgb(230, 36, 41)',
  red: 'rgb(210, 23, 40)',
  redDark: 'rgb(180, 10, 39)',
  redError: 'rgba(210, 23, 40, 0.15)',
  blueBack: 'rgba(55, 110, 210, 0.3)',
  drawerText: 'rgb(255, 255, 255)',
  headerBack: 'rgb(233, 236, 239)',
  gold: 'rgb(255, 215, 0)',
  bronze: 'rgb(205, 127, 50)',
}

const today = new Date()
const [day, month, year] = [
  today.getDate(),
  today.getMonth() + 1,
  today.getFullYear(),
]

// Halloween theme!
if ((day >= 26 && month === 10) || (day <= 3 && month === 11))
  colours = {
    ...colours,
    blueLight: 'rgb(108, 117, 125)',
    blue: 'rgb(57, 62, 68)',
    blueDark: 'rgb(26, 29, 32)',
    blueVeryDark: 'rgb(0, 0, 0)',
    redLight: 'rgb(255, 166, 77)',
    red: 'rgb(255, 140, 26)',
    redDark: 'rgb(230, 115, 0)',
    redError: 'rgba(255, 166, 77, 0.3)',
    blueBack: 'rgba(171, 177, 182, 0.3)',
    drawerText: 'rgb(255, 166, 77)',
    headerBack: 'rgb(255, 166, 77)',
  }

// Christmas theme!
if ((month === 12 && day >= 20) || (month === 1 && day <= 6))
  colours = {
    ...colours,
    blueLight: 'rgb(150, 225, 150)',
    blue: 'rgb(130, 220, 120)',
    blueDark: 'rgb(100, 215, 90)',
    blueVeryDark: 'rgb(70, 210, 60)',
    blueBack: 'rgba(150, 225, 150, 0.3)',
    drawerText: 'rgb(0, 40, 0)',
    headerBack: 'rgb(0, 40, 0)',
  }

// Easter theme!
if (year === 2027 && month === 3 && day >= 22)
  colours = {
    ...colours,
    blueLight: 'rgb(150, 225, 150)',
    blue: 'rgb(130, 220, 120)',
    blueDark: 'rgb(100, 215, 90)',
    blueVeryDark: 'rgb(70, 210, 60)',
    redLight: 'rgb(255, 175, 200)',
    red: 'rgb(255, 150, 180)',
    redDark: 'rgb(255, 125, 160)',
    redError: 'rgba(255, 175, 200, 0.3)',
    blueBack: 'rgba(150, 225, 150, 0.3)',
    drawerText: 'rgb(26, 29, 32)',
    headerBack: 'rgb(26, 29, 32)',
  }

// Development theme!
if (REACT_HOST === 'localhost')
  colours = {
    ...colours,
    drawerText: 'rgb(0, 0, 0)',
    headerBack: 'rgb(0, 0, 0)',
  }

export { colours }

export const titlesIscrizioni = {
  titleDelete: 'Eliminare la squadra?',
  titleIndirizzo: 'Cambio di indirizzo',
  titleSpostamentoInfo: 'Spostamento gara',
  titleSpostamentoDomanda: 'Richiesta di spostamento gara',
  titleSpostamentoAccetta: 'Spostamento accettato',
  titleSpostamentoRifiuta: 'Spostamento rifiutato',
  titleRisultato: 'Invia risultato',
  titleArbitraggio: 'Richiesta di arbitraggio',
  titleDeleteCorsi: "Eliminare l'iscrizione?",
}

export const titlesIscrizione = {
  titleCompleteAdd: 'Iscrizione effettuata correttamente',
  titleCompleteUpdate: 'Iscrizione aggiornata correttamente',
  titleIncomplete: 'Salvataggio effettuato correttamente',
  titleInfoNome: 'Attenzione!',
  titleInfoNote: 'Attenzione!',
  titleInfoPreferenze: 'Abbinamenti e alternanze',
  titleIndisp: 'Indisponibilità palestra',
  titleIndispTyping: 'Digitazione disabilitata',
  titleDeroga: 'Deroga e fuori classifica',
}

export const titlesAffiliazione = {
  titleSuccessAdd: 'Società creata correttamente',
  titleSuccessUpdate: 'Società aggiornata correttamente',
  titleDelete: 'Eliminare la società?',
}

export const titlesArbitri = {
  titleRimborso: 'Generazione rimborso spese',
}

export const titlesArbitro = {
  titleSuccessAdd: 'Arbitro creato correttamente',
  titleSuccessUpdate: 'Profilo aggiornato correttamente',
  titleDelete: "Eliminare l'arbitro?",
  titleDisponibilita: 'Disponibilità settimanali',
  titleSocieta: 'Società incompatibili',
  titleIndisp: 'Indisponibilità puntuali',
  titleIndispTyping: 'Digitazione disabilitata',
  titleActive: 'Arbitro attivo o inattivo',
}

export const titlesImpostazioni = {
  titleSuccess: 'Impostazioni aggiornate correttamente',
  titleZone: 'Zone',
  titleDomeniche: 'Giornate',
  titleAccoppiamenti: 'Accoppiamenti',
  titleCampionati: 'Campionati',
  titleCategorie: 'Categorie',
  titleTabelloni: 'Formule tabelloni',
  titleTabellone: 'Nuovo tabellone',
  titleFeatures: 'Funzionalità',
  titleContatti: 'Contatti',
  titleMail: 'Impostazioni mail',
  titleMailTest: 'Mail di prova',
  titleAlgoritmi: 'Impostazioni algoritmi',
  titleCorsi: 'Corsi',
  titleAvanzate: 'Impostazioni avanzate',
  titleGoogleMapsTest: 'Test API Google Maps',
  titleResetPassword: 'Reset password',
}

export const titlesCalendari = {
  titleEditCalendario: 'Spostamento gara',
  titleEditRisultato: 'Risultato',
  titleEditPenalita: 'Penalità',
  titleEditOmologa: 'Omologazione',
  titleEditArbitraggio: 'Arbitraggio',
  titleEditRipescaggio: 'Ripescaggio',
  titleDeleteGara: 'Eliminazione gara',
}

export const titlesProvvedimenti = {
  titleEditSanzioneRisultato: 'Sanzione per risultato inviato in ritardo',
  titleEditSanzioneReferto: 'Sanzione per referto inviato in ritardo',
}

export const titlesDesignazioni = {
  titleDesignazione: 'Designazione',
  titleDesignazione1: 'Designazione come 1° arbitro',
  titleDesignazione2: 'Designazione come 2° arbitro',
  titleDesignazioneDomanda: 'Designazione',
  titleDesignazioneAccetta: 'Designazione accettata',
  titleDesignazioneRifiuta: 'Designazione rifiutata',
}

export const titlesRimborso = {
  titleRimborso: 'Rimborso',
  titleAddSuccess: 'Rimborso creato',
  titleUpdateSuccess: 'Rimborso aggiornato',
  titlePagato: 'Pagamento',
  titlePagatoSuccess: 'Stato del pagamento aggiornato',
  titleDelete: 'Eliminare il rimborso?',
  titleDeleteSuccess: 'Rimborso eliminato',
}

export const titlesRendiconto = {
  titleRendiconto: 'Rendiconto',
  titleAddSuccess: 'Rendiconto creato',
  titleUpdateSuccess: 'Rendiconto aggiornato',
}

export const titlesArbitraggi = {
  titleSuccess: 'Richiesta di arbitraggio creata',
  titleDelete: 'Eliminazione richiesta di arbitraggio',
}

export const titlesDistinte = {
  titleDelete: 'Eliminare la distinta?',
}

export const titlesDistinta = {
  titleCompleteAdd: 'Distinta creata correttamente',
  titleCompleteUpdate: 'Distinta aggiornata correttamente',
  titlePlayers: 'Selezione atleti',
  titleStaff: 'Selezione staff',
}

export const phrasesIscrizioni = {
  phrasesIndirizzoSuccess: "L'indirizzo è stato aggiornato correttamente.",
  phraseSpostamentoDomandaSuccess:
    'La richiesta di spostamento è stata presa in carico. Non appena la società avversaria accetterà lo spostamento, le variazioni saranno visibili nel calendario.',
  phraseSpostamentoAccetta:
    'Lo spostamento è stato accettato, le variazioni sono già visibili nel calendario.',
  phraseSpostamentoRifiuta:
    'Lo spostamento è stato rifiutato, la calendarizzazione della gara rimane invariata.',
  phraseRisultatoSuccess:
    'Il risultato è stato inviato correttamente ed è già visibile nel calendario.',
  phraseArbitraggioSuccess: "L'arbitraggio è stato richiesto correttamente.",
}

export const phrasesIscrizione = {
  phraseInfoNome: (
    <span>
      Non indicate la <b>categoria</b> nel nome della squadra: per quella c'è
      una sezione apposita.
    </span>
  ),
  phraseInfoNote: (
    <span>
      Ogni anno riceviamo centinaia di richieste e facciamo del nostro meglio
      per soddisfarle tutte. Siate concisi ed efficaci.
      <br />
      <br />
      1) <b>Segnate le richieste di abbinamento e alternanza</b> nella sezione
      apposita, senza riscriverle anche qui.
      <br />
      <br />
      2) <b>Segnate le indisponibilità della palestra</b> nel "calendarietto"
      apposito, senza riscriverle anche qui.
      <br />
      <br />
      3) <b>Non chiedete l'arbitro</b> nè qui nè via email: potrete farlo dopo
      la pubblicazione dei calendari con la funzionalità apposita che comparirà
      nella vostra homepage.
      <br />
      <br />
      4) <b>Non inserite comunicazioni per gli avversari</b> tipo "non abbiamo
      le docce": scrivete direttamente a loro.
    </span>
  ),
  phraseInfoPreferenze: (
    <span>
      Per <b>abbinamento</b> si intende una squadra (della propria società) con
      cui si vorrebbe giocare in casa nelle stesse giornate.
      <br />
      Per <b>alternanza</b> si intende una squadra (della propria società) con
      cui si vorrebbe giocare in casa in giornate diverse.
      <br />
      <br />
      <b>
        Affinchè una squadra possa essere abbinata o alternata all'iscrizione
        corrente, bisogna che sia già stata iscritta precedentemente (senza
        preferenze di abbinamento o alternanza, che saranno gestite in
        automatico).
      </b>
      <br />
      <br />
      Per esempio, per richiedere che le squadre A e B giochino in casa nelle
      stesse giornate, bisognerà prima iscrivere la squadra A senza specificare
      alcun abbinamento e poi iscrivere la squadra B specificando che dovrà
      essere abbinata alla squadra A. Fatto questo, il sistema aggiornerà
      automaticamente anche i dati della squadra A abbinandola alla squadra B.
      <br />
      <br />
      Un esempio più complesso e abbastanza comune è il seguente: ci sono 4
      squadre (A, B, C, D) che devono essere abbinate e alternate a coppie, cioè
      con A e B che giocano in casa nelle stesse giornate ma in giornate diverse
      rispetto a C e D. In questo caso bisognerà inserire per ciascuna squadra 1
      abbinamento (con la squadra che dovrà giocare in casa nelle stesse
      giornate) e 2 alternanze (con le due squadre che dovranno giocare in casa
      in giornate diverse). Quindi A dovrà essere abbinata a B e alternata a C e
      D, e così via.
    </span>
  ),
  phraseIndisp:
    'Le indisponibilità della palestra sono le date in cui non si può giocare in casa e si preferirebbe giocare in trasferta.',
  phraseIndispTyping:
    "Cliccare sull'icona del calendario per selezionare le date.",
  phraseDeroga: (
    <span>
      Una squadra "in deroga" partecipa normalmente alla fase a gironi del
      campionato e può qualificarsi alle fasi finali. È contrassegnata da un
      punto esclamativo giallo nelle pagine Iscrizioni e Classifiche.
      <br />
      <br />
      Una squadra "fuori classifica" partecipa normalmente alla fase a gironi
      del campionato ma non può qualificarsi alle fasi finali. È contrassegnata
      da un punto esclamativo rosso nelle pagine Iscrizioni e Classifiche.
    </span>
  ),
}

export const phrasesArbitro = {
  phraseDisponibilita:
    'Le disponibilità settimanali sono i giorni della settimana e i relativi orari in cui ci si dichiara disponibili ad arbitrare.' +
    ' Per aggiungere una nuova disponibilità, cliccare su "Nuova disponibilità" poi scegliere un giorno della settimana e infine gli orari, intesi come orari di inizio gara.',
  phraseSocieta:
    'Le società incompatibili sono le società che non si possono arbitrare o che si preferisce non arbitrare.' +
    ' Le ragioni di tale incompatibilità vanno sempre e comunque discusse con il designatore.',
  phraseIndisp:
    'Le indisponibilità puntuali sono le date in cui non si riesce ad arbitrare anche se rientrano' +
    ' nelle proprie disponibilità settimanali, per esempio a causa di vacanze o altri impegni personali.',
  phraseIndispTyping:
    "Cliccare sull'icona del calendario per selezionare le date.",
  phraseActive:
    'Un arbitro "inattivo" viene nascosto durante il processo di designazione, così che non venga designato per nessuna gara, ma rimane comunque presente in piattaforma.' +
    ' Questa funzionalità è pensata per non dover eliminare gli arbitri che hanno sospeso o terminato la loro attività.',
}

export const phrasesImpostazioni = {
  phraseSuccess: "L'aggiornamento delle impostazioni è avvenuto correttamente!",
  phraseResetPasswordRequest:
    "Se il codice inserito è corretto, verrà mandata una mail all'indirizzo associato con le istruzioni da seguire.",
  phraseResetPassword: 'La password è stata resettata correttamente.',
}

export const phrasesCalendari = {
  phraseCalendarioSuccess: 'Lo spostamento è stato registrato.',
  phraseRisultatoSuccess: 'Il risultato è stato aggiornato correttamente.',
  phrasePenalitaSuccess: 'Le penalità sono state aggiornate correttamente.',
  phraseOmologaSuccess: "L'omologa è stata aggiornata correttamente.",
  phraseArbitraggioSuccess: "L'arbitraggio è stato aggiornato correttamente.",
  phraseRipescaggioSuccess: 'Il ripescaggio è stato effettuato correttamente.',
  phraseDeleteGara:
    'Eliminando questa gara, verranno eliminati anche eventuali relativi spostamenti, designazioni e richieste di arbitraggio.',
  phraseDeleteGaraSuccess:
    "L'eliminazione della gara e di eventuali spostamenti, designazioni e richieste di arbitraggio è stata effettuata correttamente.",
}

export const phrasesDesignazione = {
  phraseDesignazioneDomandaSuccess:
    'La proposta di designazione è stata inviata.',
  phraseDesignazioneAccetta: 'La designazione è stata accettata.',
  phraseDesignazioneRifiuta: 'La designazione è stata rifiutata.',
}

export const phrasesRimborso = {
  phraseAddSuccess: 'Il rimborso è stato creato correttamente.',
  phraseUpdateSuccess: 'Il rimborso è stato aggiornato correttamente.',
  phrasePagatoSuccess:
    'Lo stato del pagamento è stato aggiornato correttamente.',
  phraseDelete:
    'Eliminando questo rimborso, verranno cancellate anche tutte le informazioni inserite.' +
    ' Sarà poi possibile generarne uno nuovo con le stesse partite.',
  phraseDeleteSuccess: 'Il rimborso è stato eliminato correttamente.',
}

export const phrasesRendiconto = {
  phraseAddSuccess: 'Il rendiconto è stato creato correttamente.',
  phraseUpdateSuccess: 'Il rendiconto è stato aggiornato correttamente.',
}

export const phrasesArbitraggi = {
  phraseSuccess: 'La richiesta di arbitraggio è stata creata correttamente.',
  phraseDelete: 'Eliminare la richiesta di arbitraggio?',
  phraseDeleteSuccess:
    'La richiesta di arbitraggio è stata eliminata correttamente.',
}

export const phrasesDistinte = {
  phraseDelete: 'Successivamente sarà possibile crearne una nuova.',
  phraseDeleteSuccess: 'La distinta è stata eliminata correttamente.',
}

export const GIORNI = [
  'Lunedì',
  'Martedì',
  'Mercoledì',
  'Giovedì',
  'Venerdì',
  'Sabato',
  'Domenica',
]

export const WEEK_DAYS = ['DO', 'LU', 'MA', 'ME', 'GI', 'VE', 'SA']

export const MONTHS = [
  'Gennaio',
  'Febbraio',
  'Marzo',
  'Aprile',
  'Maggio',
  'Giugno',
  'Luglio',
  'Agosto',
  'Settembre',
  'Ottobre',
  'Novembre',
  'Dicembre',
]

export const OPZIONI_ISCRIZIONE = [
  'senza-palestra',
  'altre-richieste',
  'modulo-privacy',
  'regolamento',
]

export const GIRONI_FUNCTIONS = ['sposta', 'scambia', 'metti', 'togli']

export const TIPOLOGIE_SPOSTAMENTO = {
  sposta: {
    short: 'Cambio data/ora',
    label: 'Cambio data/ora',
    requiresNewDate: true,
    requiresNewTime: true,
    requiresPayment: true,
  },
  'sposta-inverti': {
    short: 'Cambio data/ora e inversione',
    label: 'Cambio data/ora e inversione di campo',
    requiresNewDate: true,
    requiresNewTime: true,
    requiresPayment: true,
  },
  inverti: {
    short: 'Inversione',
    label: 'Inversione di campo',
  },
  rimanda: {
    short: 'Rinvio',
    label: 'Rinvio a data da destinarsi',
  },
}

export const SQUADRA_INVIO_RISULTATO = {
  casa: { label: 'Squadra in casa' },
  trasferta: { label: 'Squadra in trasferta' },
  vincente: { label: 'Squadra vincente' },
}

export const NOMI_GIRONI = ['1-2-3', 'VA01-VA02-VA03']
export const NOMI_GIRONI_RESTART = ['per-campionato', 'per-categoria']
export const NUMERI_GARA = ['per-campionato', 'per-girone']

export const TITOLI_STUDIO = [
  'NESSUN TITOLO DI STUDIO',
  'LICENZA ELEMENTARE',
  'LICENZA MEDIA',
  "TITOLO DI ISTRUZIONE SECONDARIA SUPERIORE (SCOLASTICA ED EXTRA-SCOLASTICA) CHE NON PERMETTE L'ACCESSO ALL'UNIVERSITÀ",
  "DIPLOMA DI ISTRUZIONE SECONDARIA SUPERIORE CHE PERMETTE L'ACCESSO ALL'UNIVERSITÀ",
  'DIPLOMA TERZIARIO EXTRA-UNIVERSITARIO',
  'DIPLOMA UNIVERSITARIO',
  'LAUREA - VECCHIO O NUOVO ORDINAMENTO',
  'TITOLO DI STUDIO POST-LAUREA',
  'MASTER UNIVERSITARIO DI PRIMO LIVELLO',
  'DIPLOMA DI SPECIALIZZAZIONE',
  'TITOLO DI DOTTORE DI RICERCA',
  'LAUREA DI PRIMO LIVELLO',
  'DIPLOMA DI LAUREA',
  'LAUREA SPECIALISTICA A CICLO UNICO',
  'LAUREA SPECIALISTICA',
  'MASTER UNIVERSITARIO DI SECONDO LIVELLO',
]

export const SESSI = [
  { key: 'F', label: 'Femmine' },
  { key: 'M', label: 'Maschi' },
]

export const TESSERE = [
  { key: 'Atleta', group: 'players', order: 3, color: 'success' },
  { key: 'Ricreativo', group: 'players', order: 4, color: 'info' },
  { key: 'Dirigente', group: 'staff', order: 2, color: 'warning' },
  { key: 'Tecnici', group: 'staff', order: 1, color: 'error' },
]

export const TESSERATI_PLAYERS_INCOMPATIBILITIES = [
  { key: undefined, label: 'Idonei' },
  { key: 'fuori-eta', label: 'Fuori età' },
  { key: 'altro-sesso', label: 'Altro sesso' },
  { key: 'altra-squadra', label: 'Altra squadra' },
]

export const PLAYERS_FLAGS = [
  { key: 'C', label: 'Capitano' },
  { key: 'L1', label: 'Libero 1', incompatibleWith: ['L2'] },
  { key: 'L2', label: 'Libero 2', incompatibleWith: ['L1'] },
]

export const STAFF_FLAGS = [
  { key: 'A', label: 'Allenatore', onlyRoles: ['Tecnici'] },
  { key: 'VA', label: 'Vice Allenatore', onlyRoles: ['Tecnici'] },
  { key: 'DA', label: 'Dirigente Accompagnatore', onlyRoles: ['Dirigente'] },
  { key: 'M', label: 'Medico', onlyRoles: ['Dirigente'] },
  { key: 'F', label: 'Fisioterapista', onlyRoles: ['Dirigente'] },
  { key: 'AA', label: 'Arbitro Associato' },
  { key: 'R', label: 'Refertista' },
]
